export default __webpack_public_path__ + "static/char-v-09-c8cfc90dda423ded662e0aeadd14fb56.png";